import { useCallback, useMemo, useState } from 'react'

import { ComponentsService } from 'services'
import { PanelStore } from 'stores'

const componentsServiceConnection = new ComponentsService()

export function useSOAEmbed() {
  const [isGeneratingEmbedURL, setIsGeneratingEmbedURL] = useState(false)
  const [error, setError] = useState(false)

  const getEmbedURL = useCallback(async () => {
    try {
      setIsGeneratingEmbedURL(true)

      const workspaceId = Object(PanelStore.selectedPanel)?.id || ''
      const categoryId = Object(PanelStore.selectedPanel)?.category?.id

      const createdEmbedURL = await componentsServiceConnection.generateEmbedURL({
        chartType: 'shareOfAttention',
        filters: {
          workspaceId,
          categoryId,
        },
      })

      return createdEmbedURL
    } catch (e) {
      console.error(e)
      setError(true)
      return ''
    } finally {
      setIsGeneratingEmbedURL(false)
    }
  }, [])

  const memoizedValue = useMemo(
    () => ({
      getEmbedURL,
      isGeneratingEmbedURL,
      error,
    }),
    [getEmbedURL, isGeneratingEmbedURL, error]
  )

  return memoizedValue
}
